export default __webpack_public_path__ + "static/media/spaceman.8fba404d.png";